import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getArtistBySlug, getArtistReleases, getArtistAppearances, getImageUrl, formatDateET } from '../utils/api';
import { useSEO } from '../utils/seo';
import { Instagram, Music2, ExternalLink, Globe, Calendar, MapPin } from 'lucide-react';
import './ArtistPage.css';

const SocialIcon = ({ platform }) => {
  const icons = {
    spotify: <Music2 size={20} />,
    instagram: <Instagram size={20} />,
    globe: <Globe size={20} />,
  };
  
  const svgIcons = {
    soundcloud: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M1 18V11h1v7H1zm2-2V9h1v7H3zm2 2V7h1v11H5zm2-1V8h1v9H7zm2 1V5h1v13H9zm2-1V8h1v9h-1zm2 1V3.5c0 0 .8-.5 1.5-.5s1.5.5 1.5.5V18h-3zm5 0V6c2.5 0 4.5 2.2 4.5 5s-2 5-4.5 5z"/></svg>
    ),
    youtube: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2s-.2-1.6-.9-2.3c-.9-.9-1.8-.9-2.3-1C17 2.6 12 2.6 12 2.6s-5 0-8.3.3c-.5.1-1.4.1-2.3 1-.7.7-.9 2.3-.9 2.3S.2 8.1.2 10v1.8c0 1.9.3 3.8.3 3.8s.2 1.6.9 2.3c.9.9 2 .9 2.5 1 1.8.2 7.6.2 7.6.2s5 0 8.3-.3c.5-.1 1.4-.1 2.3-1 .7-.7.9-2.3.9-2.3s.3-1.9.3-3.8V10c0-1.9-.3-3.8-.3-3.8zM9.6 15.1V8.4l6.3 3.4-6.3 3.3z"/></svg>
    ),
    twitter: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
    ),
    tiktok: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.11V9a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.87a8.28 8.28 0 004.77 1.52V7a4.84 4.84 0 01-1-.31z"/></svg>
    ),
    facebook: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
    ),
    bandcamp: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M0 18.75l7.437-13.5H24l-7.438 13.5z"/></svg>
    ),
    beatport: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/><path d="M8 8l8 4-8 4z"/></svg>
    ),
    apple_music: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043A5.022 5.022 0 0019.7.22a10.56 10.56 0 00-1.878-.133H6.178A10.56 10.56 0 004.3.22a5.022 5.022 0 00-1.874.67C1.308 1.563.563 2.563.246 3.874a9.23 9.23 0 00-.24 2.19c-.006.14-.006.28-.006.42v10.032c0 .14 0 .28.006.42a9.23 9.23 0 00.24 2.19c.317 1.31 1.062 2.31 2.18 3.043a5.022 5.022 0 001.874.67 10.56 10.56 0 001.878.133h11.644a10.56 10.56 0 001.878-.133 5.022 5.022 0 001.874-.67c1.118-.733 1.863-1.733 2.18-3.043a9.23 9.23 0 00.24-2.19c.006-.14.006-.28.006-.42V6.544c0-.14 0-.28-.006-.42zM16.95 17.588c0 .282-.008.564-.088.838-.2.682-.708 1.09-1.382 1.17a2.76 2.76 0 01-.468.01c-.622-.044-1.078-.393-1.238-.988a2.1 2.1 0 01-.058-.462V12.14a1.04 1.04 0 00-.712-.998c-.186-.062-.38-.062-.576-.032-.466.072-.754.392-.826.862-.016.1-.018.198-.018.298v5.866c0 .282-.008.564-.088.838-.2.682-.708 1.09-1.382 1.17a2.76 2.76 0 01-.468.01c-.622-.044-1.078-.393-1.238-.988a2.1 2.1 0 01-.058-.462V12.14a1.04 1.04 0 00-.712-.998c-.186-.062-.38-.062-.576-.032-.466.072-.754.392-.826.862-.016.1-.018.198-.018.298v5.866c0 .282-.008.564-.088.838-.2.682-.708 1.09-1.382 1.17a2.76 2.76 0 01-.468.01c-.622-.044-1.078-.393-1.238-.988A2.1 2.1 0 014 18.704V5.192c0-.036.002-.072.006-.108.066-.604.458-1.036 1.052-1.136.08-.014.162-.02.244-.02h.396c.59.04 1.04.398 1.184.978.04.16.054.324.054.49v.002c0 .032 0 .064.002.096.014.306.228.55.536.58.042.004.084.004.126.002.282-.02.49-.222.518-.506.004-.04.004-.08.004-.12V5.192c0-.036.002-.072.006-.108.066-.604.458-1.036 1.052-1.136.08-.014.162-.02.244-.02h.396c.59.04 1.04.398 1.184.978.04.16.054.324.054.49v.002l.002.096c.014.306.228.55.536.58.042.004.084.004.126.002.282-.02.49-.222.518-.506.004-.04.004-.08.004-.12V5.192c0-.036.002-.072.006-.108.066-.604.458-1.036 1.052-1.136.08-.014.162-.02.244-.02h.396c.59.04 1.04.398 1.184.978.04.16.054.324.054.49v12.192z"/></svg>
    ),
  };

  if (icons[platform]) return icons[platform];
  if (svgIcons[platform]) return svgIcons[platform];
  return <Globe size={20} />;
};

const ArtistPage = () => {
  const { slug } = useParams();
  const [artist, setArtist] = useState(null);
  const [releases, setReleases] = useState([]);
  const [appearances, setAppearances] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchArtistData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const fetchArtistData = async () => {
    try {
      const [artistData, releasesData, appearancesData] = await Promise.all([
        getArtistBySlug(slug),
        getArtistReleases(slug),
        getArtistAppearances(slug).catch(() => [])
      ]);
      setArtist(artistData);
      setReleases(releasesData);
      setAppearances(appearancesData);
    } catch (error) {
      console.error('Failed to load artist', error);
    } finally {
      setLoading(false);
    }
  };

  // SEO meta tags (must be called before any early returns)
  useSEO({
    title: artist?.name || 'Artist',
    description: artist?.bio?.substring(0, 160) || `${artist?.name || 'Artist'} on Anyone Music Records`,
    image: artist?.profile_image || artist?.image || '',
    type: 'profile'
  });

  if (loading) {
    return (
      <div className="artist-page">
        <div className="loading-container">
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  if (!artist) {
    return (
      <div className="artist-page">
        <div className="error-container">
          <h1>Artist Not Found</h1>
          <p>The artist you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }

  const heroBg = getImageUrl(artist.hero_image) || getImageUrl(artist.image);
  const socialEntries = artist.social_links
    ? Object.entries(artist.social_links).filter(([, url]) => url)
    : [];

  return (
    <div className="artist-page" data-testid="artist-page">
      {/* Artist Header */}
      <section className="artist-header">
        <div className="artist-header-bg" style={{backgroundImage: heroBg ? `url(${heroBg})` : 'none'}}></div>
        <div className="artist-header-overlay"></div>
        
        <div className="container artist-header-content">
          <div className="artist-image-container">
            {artist.image && (
              <img src={getImageUrl(artist.image)} alt={artist.name} className="artist-profile-image" />
            )}
          </div>
          
          <div className="artist-info-main">
            <h1 data-testid="artist-name">{artist.name}</h1>
            <p className="artist-genre">{artist.genre}</p>
            
            {socialEntries.length > 0 && (
              <div className="artist-social-links" data-testid="artist-social-links">
                {socialEntries.map(([platform, url]) => (
                  <a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={platform.replace('_', ' ')}
                    data-testid={`social-link-${platform}`}
                  >
                    <SocialIcon platform={platform} />
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Artist Bio */}
      {artist.bio && (
        <section className="artist-bio-section">
          <div className="container">
            <div className="artist-bio">
              <h2>About</h2>
              <div className="artist-bio-text">
                {artist.bio.split('\n').map((paragraph, index) => (
                  paragraph.trim() && (
                    <p key={index}>{paragraph}</p>
                  )
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Artist Releases */}
      <section className="artist-releases-section">
        <div className="container">
          <h2>Releases</h2>
          
          {releases.length === 0 ? (
            <p className="no-releases">No releases yet</p>
          ) : (
            <div className="releases-grid">
              {releases.map((release) => (
                <Link
                  to={`/releases/${release.slug || release.id}`}
                  key={release.id}
                  className="release-card"
                  data-testid={`release-card-${release.id}`}
                >
                  <div className="release-artwork-wrapper">
                    <img src={getImageUrl(release.artwork)} alt={release.title} className="release-artwork" />
                    <div className="release-overlay">
                      <div className="stream-button">
                        <ExternalLink size={24} />
                        <span>View Release</span>
                      </div>
                    </div>
                  </div>
                  <div className="release-info">
                    <h3>{release.title}</h3>
                    <p className="release-genre">{release.genre}</p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Artist Appearances */}
      {appearances.length > 0 && (
        <section className="artist-appearances-section" data-testid="artist-appearances">
          <div className="container">
            <h2>Upcoming Appearances</h2>
            <div className="appearances-grid">
              {appearances.map((app) => (
                <div key={app.id} className="appearance-card" data-testid={`appearance-${app.id}`}>
                  {app.image && (
                    <div className="appearance-image">
                      <img src={getImageUrl(app.image)} alt={app.title} />
                    </div>
                  )}
                  <div className="appearance-info">
                    <h3>{app.title}</h3>
                    <div className="appearance-meta">
                      <span><MapPin size={14} /> {app.venue}, {app.city}</span>
                      <span><Calendar size={14} /> {formatDateET(app.date, { month: 'long', day: 'numeric', year: 'numeric' })}</span>
                      {app.time && <span>{app.time}</span>}
                    </div>
                    {app.description && <p className="appearance-desc">{app.description}</p>}
                    {app.external_link && (
                      <a href={app.external_link} target="_blank" rel="noopener noreferrer" className="appearance-link">
                        <ExternalLink size={14} /> Event Details
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default ArtistPage;
